import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import { ScrollPanelModule } from 'primeng/scrollpanel';
import { InputTextModule } from 'primeng/inputtext';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TabViewModule } from 'primeng/tabview';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FileUploadModule } from 'primeng/fileupload';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { GMapModule } from 'primeng/gmap';
import { DialogModule } from 'primeng/dialog';
import { DataViewModule } from 'primeng/dataview';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { SidebarModule } from 'primeng/sidebar';
import { DropdownModule } from 'primeng/dropdown';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { PickListModule } from 'primeng/picklist';
import { TreeTableModule } from 'primeng/treetable';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProgressBarModule } from 'primeng/progressbar';
import { PasswordModule } from 'primeng/password';
import { AccordionModule } from 'primeng/accordion';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { SearchProductComponent } from './popup-search/search-product/search-product.component';
import { SearchCustomerGroupComponent } from './popup-search/search-customer-group/search-customer-group.component';
import { SearchAreazoneComponent } from './popup-search/search-areazone/search-areazone.component';
import { SearchCustomerComponent } from './popup-search/search-customer/search-customer.component';
import { SearchCustgroupdiscountComponent } from './popup-search/search-custgroupdiscount/search-custgroupdiscount.component';
import { SearchBankbookComponent } from './popup-search/search-bankbook/search-bankbook.component';
import { SearchEmployeeComponent } from './popup-search/search-employee/search-employee.component';

import { ContentComponent } from './content/content.component';
import { FooterComponent } from './footer/footer.component';
import { TopbarComponent } from './topbar/topbar.component';
import { AppMenuComponent, AppSubMenuComponent } from './menu/menu.component';

import { OnlyNumberDirective } from '../Directive/only-number.directive';

@NgModule({
  declarations: [
    SearchProductComponent,
    SearchCustomerGroupComponent,
    SearchAreazoneComponent,
    SearchCustomerComponent,
    SearchCustgroupdiscountComponent,
    SearchBankbookComponent,
    SearchEmployeeComponent,
    ContentComponent,
    FooterComponent,
    AppMenuComponent,
    TopbarComponent,
    AppSubMenuComponent,
    OnlyNumberDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ScrollPanelModule,
    InputTextModule,
    TableModule,
    BreadcrumbModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    AutoCompleteModule,
    CalendarModule,
    CheckboxModule,
    DynamicDialogModule,
    InputTextareaModule,
    TabViewModule,
    RadioButtonModule,
    FileUploadModule,
    MessagesModule,
    MessageModule,
    GMapModule,
    DialogModule,
    DataViewModule,
    PanelModule,
    CardModule,
    SidebarModule,
    DropdownModule,
    ToggleButtonModule,
    PickListModule,
    TreeTableModule,
    OverlayPanelModule,
    InputSwitchModule,
    ProgressBarModule,
    PasswordModule,
    AccordionModule,
    ProgressSpinnerModule,
  ],
  exports: [
    ContentComponent,
    FooterComponent,
    TopbarComponent,
    AppMenuComponent, AppSubMenuComponent,
    ReactiveFormsModule,
    FormsModule,
    ScrollPanelModule,
    InputTextModule,
    TableModule,
    BreadcrumbModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    AutoCompleteModule,
    CalendarModule,
    CheckboxModule,
    DynamicDialogModule,
    InputTextareaModule,
    TabViewModule,
    RadioButtonModule,
    FileUploadModule,
    MessagesModule,
    MessageModule,
    GMapModule,
    DialogModule,
    DataViewModule,
    PanelModule,
    CardModule,
    SidebarModule,
    DropdownModule,
    ToggleButtonModule,
    PickListModule,
    TreeTableModule,
    OverlayPanelModule,
    InputSwitchModule,
    ProgressBarModule,
    PasswordModule,
    AccordionModule,
    ProgressSpinnerModule,
    OnlyNumberDirective
  ],
  entryComponents: [
    SearchProductComponent,
    SearchCustomerGroupComponent,
    SearchAreazoneComponent,
    SearchCustomerComponent,
    SearchCustgroupdiscountComponent,
    SearchBankbookComponent,
    SearchEmployeeComponent,
  ]
})
export class SharedModule { }
